module.exports = __webpack_public_path__ + "4d23e6d71f491c43da0bc33d347000ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescenceScale/strong@2x.png
// module id = 854
// module chunks = 0